import React from 'react'
import '../App.css'
import winnerMain from "../finalist_photos/2025finals.webp"
import LazyLoad from 'react-lazyload';
import Kelly from "../finalistsheadshot/kelly.webp"
import Ameya from "../finalistsheadshot/Ameyatwo.webp"
import Colin from "../finalistsheadshot/Colinding.webp"
import Cyrus from "../finalistsheadshot/Ghane.webp"
import Yanrui from "../finalistsheadshot/Yarnui.webp"
import JiaChen from "../finalistsheadshot/JiaChenQu.webp"

function WinnersFive() {
  return (
    <div>
        <div>
            <div className="cool-background">
                <div className="container">
                    <div>
                        <LazyLoad once offset={100}>
                            <img src={winnerMain} className="cool-image-guy-holding-blocks" style={{width: '100%'}}/>
                        </LazyLoad>
                    </div>
                </div>
            </div>
            <div className="container">
                <div style={{marginTop: '30px'}}>
                    <p style={{fontSize: '27px'}}><b>2025 IRO Winners</b></p>

                    <p>The 2025 International Finals Exam took place from June 6th to June 8th, 2025.
                        <br/><br/>
The 2025 IRO Finals showcased some of the most promising young minds in the world. With its dedication to critical thinking and real-world application of knowledge, the IRO is shaping the next generation of innovative leaders who will tackle global challenges and make a lasting impact on society.
                    </p>
                </div>

                <div className="visible-winners">
                    <div>
                        <div>
                            <p style={{fontWeight: '600', fontSize: '14px'}}>Gold Medal:</p>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <div>
                                    <LazyLoad once offset={100}>
                                        <img src={Kelly} style={{ height: "230px", width: "auto" }} className="card-img-top no-invert-image-partners-css" alt="..." />
                                    </LazyLoad>
                                </div>
                                <div style={{marginLeft: '20px'}}>
                                    <div className="card-body">
                                    <h5 className="card-title" style={{fontSize: '21px'}}><b>Kelly Lock</b></h5>
                                    {/* <p className="card-text" style={{marginTop: '10px', fontSize: '17px'}}>won 1st Place.</p> */}
                                    </div>
                                    {/* <div style={{marginTop: '20px', fontSize: '17px'}}>
                                        <p>[Bio coming soon]</p>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div>
                        <div>
                            <p style={{fontWeight: '600', fontSize: '14px'}}>Silver Medal:</p>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <div>
                                    <LazyLoad once offset={100}>
                                        <img src={Ameya} style={{ height: "230px", width: "auto" }} className="card-img-top no-invert-image-partners-css" alt="..." />
                                    </LazyLoad>
                                </div>
                                <div style={{marginLeft: '20px'}}>
                                    <div className="card-body">
                                    <h5 className="card-title" style={{fontSize: '21px'}}><b>Ameya Kharade</b></h5>
                                    {/* <p className="card-text" style={{marginTop: '10px', fontSize: '17px'}}>won 2nd Place and a Silver Medal.</p> */}
                                    </div>
                                    {/* <div style={{marginTop: '20px', fontSize: '17px'}}>
                                        <p>[Bio coming soon]</p>
                                    </div> */}
                                </div>
                            </div>
                            
                            <div style={{display: 'flex', alignItems: 'center', marginTop: '20px'}}>
                                <div>
                                    <LazyLoad once offset={100}>
                                        <img src={Colin} style={{ height: "230px", width: "auto" }} className="card-img-top no-invert-image-partners-css" alt="..." />
                                    </LazyLoad>
                                </div>
                                <div style={{marginLeft: '20px'}}>
                                    <div className="card-body">
                                    <h5 className="card-title" style={{fontSize: '21px'}}><b>Colin Yuanjie Ding</b></h5>
                                    {/* <p className="card-text" style={{marginTop: '10px', fontSize: '17px'}}>won 3rd Place and a Silver Medal.</p> */}
                                    </div>
                                    {/* <div style={{marginTop: '20px', fontSize: '17px'}}>
                                        <p>[Bio coming soon]</p>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div>
                        <div>
                            <p style={{fontWeight: '600', fontSize: '14px'}}>Bronze Medal:</p>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <div>
                                    <LazyLoad once offset={100}>
                                        <img src={Cyrus} style={{ height: "230px", width: "auto" }} className="card-img-top no-invert-image-partners-css" alt="..." />
                                    </LazyLoad>
                                </div>
                                <div style={{marginLeft: '20px'}}>
                                    <div className="card-body">
                                    <h5 className="card-title" style={{fontSize: '21px'}}><b>Cyrus Ghane</b></h5>
                                    {/* <p className="card-text" style={{marginTop: '10px', fontSize: '17px'}}>won 4th Place.</p> */}
                                    </div>
                                    {/* <div style={{marginTop: '20px', fontSize: '17px'}}>
                                        <p>[Bio coming soon]</p>
                                    </div> */}
                                </div>
                            </div>

                            <div style={{display: 'flex', alignItems: 'center', marginTop: '20px'}}>
                                <div>
                                    <LazyLoad once offset={100}>
                                        <img src={Yanrui} style={{ height: "230px", width: "auto" }} className="card-img-top no-invert-image-partners-css" alt="..." />
                                    </LazyLoad>
                                </div>
                                <div style={{marginLeft: '20px'}}>
                                    <div className="card-body">
                                    <h5 className="card-title" style={{fontSize: '21px'}}><b>Yanrui Li</b></h5>
                                    {/* <p className="card-text" style={{marginTop: '10px', fontSize: '17px'}}>won 5th Place.</p> */}
                                    </div>
                                    {/* <div style={{marginTop: '20px', fontSize: '17px'}}>
                                        <p>[Bio coming soon]</p>
                                    </div> */}
                                </div>
                            </div>

                            <div style={{display: 'flex', alignItems: 'center', marginTop: '20px'}}>
                                <div>
                                    <LazyLoad once offset={100}>
                                        <img src={JiaChen} style={{ height: "230px", width: "auto" }} className="card-img-top no-invert-image-partners-css" alt="..." />
                                    </LazyLoad>
                                </div>
                                <div style={{marginLeft: '20px'}}>
                                    <div className="card-body">
                                    <h5 className="card-title" style={{fontSize: '21px'}}><b>Jia Chen Qu</b></h5>
                                    {/* <p className="card-text" style={{marginTop: '10px', fontSize: '17px'}}>won 6th Place.</p> */}
                                    </div>
                                    {/* <div style={{marginTop: '20px', fontSize: '17px'}}>
                                        <p>[Bio coming soon]</p>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr/>
                </div>
                
                <div className="hidden-winners">
                    <div>
                        <div>
                            <p style={{fontWeight: '600', fontSize: '14px'}}>Gold Medal:</p>
                            <div>
                                <div>
                                    <LazyLoad once offset={100}>
                                        <img src={Kelly} style={{ height: "230px", width: "auto" }} className="card-img-top no-invert-image-partners-css" alt="..." />
                                    </LazyLoad>
                                </div>
                                <div style={{marginTop: '20px'}}>
                                    <div className="card-body">
                                    <h5 className="card-title" style={{fontSize: '21px'}}><b>Kelly Lock</b></h5>
                                    {/* <p className="card-text" style={{marginTop: '10px', fontSize: '17px'}}>won 1st Place.</p> */}
                                    </div>
                                    {/* <div style={{marginTop: '20px', fontSize: '17px'}}>
                                        <p>[Bio coming soon]</p>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div>
                        <div>
                            <p style={{fontWeight: '600', fontSize: '14px'}}>Silver Medal:</p>
                            <div>
                                <div>
                                    <LazyLoad once offset={100}>
                                        <img src={Ameya} style={{ height: "230px", width: "auto" }} className="card-img-top no-invert-image-partners-css" alt="..." />
                                    </LazyLoad>
                                </div>
                                <div style={{marginTop: '20px'}}>
                                    <div className="card-body">
                                    <h5 className="card-title" style={{fontSize: '21px'}}><b>Ameya Kharade</b></h5>
                                    {/* <p className="card-text" style={{marginTop: '10px', fontSize: '17px'}}>won 2nd Place and a Silver Medal.</p> */}
                                    </div>
                                    {/* <div style={{marginTop: '20px', fontSize: '17px'}}>
                                        <p>[Bio coming soon]</p>
                                    </div> */}
                                </div>
                            </div>
                            
                            <div style={{marginTop: '20px'}}>
                                <div>
                                    <LazyLoad once offset={100}>
                                        <img src={Colin} style={{ height: "230px", width: "auto" }} className="card-img-top no-invert-image-partners-css" alt="..." />
                                    </LazyLoad>
                                </div>
                                <div style={{marginTop: '20px'}}>
                                    <div className="card-body">
                                    <h5 className="card-title" style={{fontSize: '21px'}}><b>Colin Yuanjie Ding</b></h5>
                                    {/* <p className="card-text" style={{marginTop: '10px', fontSize: '17px'}}>won 3rd Place and a Silver Medal.</p> */}
                                    </div>
                                    {/* <div style={{marginTop: '20px', fontSize: '17px'}}>
                                        <p>[Bio coming soon]</p>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div>
                        <div>
                            <p style={{fontWeight: '600', fontSize: '14px'}}>Bronze Medal:</p>
                            <div>
                                <div>
                                    <LazyLoad once offset={100}>
                                        <img src={Cyrus} style={{ height: "230px", width: "auto" }} className="card-img-top no-invert-image-partners-css" alt="..." />
                                    </LazyLoad>
                                </div>
                                <div style={{marginTop: '20px'}}>
                                    <div className="card-body">
                                    <h5 className="card-title" style={{fontSize: '21px'}}><b>Cyrus Ghane</b></h5>
                                    {/* <p className="card-text" style={{marginTop: '10px', fontSize: '17px'}}>won 4th Place.</p> */}
                                    </div>
                                    {/* <div style={{marginTop: '20px', fontSize: '17px'}}>
                                        <p>[Bio coming soon]</p>
                                    </div> */}
                                </div>
                            </div>

                            <div style={{marginTop: '20px'}}>
                                <div>
                                    <LazyLoad once offset={100}>
                                        <img src={Yanrui} style={{ height: "230px", width: "auto" }} className="card-img-top no-invert-image-partners-css" alt="..." />
                                    </LazyLoad>
                                </div>
                                <div style={{marginTop: '20px'}}>
                                    <div className="card-body">
                                    <h5 className="card-title" style={{fontSize: '21px'}}><b>Yanrui Li</b></h5>
                                    {/* <p className="card-text" style={{marginTop: '10px', fontSize: '17px'}}>won 5th Place.</p> */}
                                    </div>
                                    {/* <div style={{marginTop: '20px', fontSize: '17px'}}>
                                        <p>[Bio coming soon]</p>
                                    </div> */}
                                </div>
                            </div>

                            <div style={{marginTop: '20px'}}>
                                <div>
                                    <LazyLoad once offset={100}>
                                        <img src={JiaChen} style={{ height: "230px", width: "auto" }} className="card-img-top no-invert-image-partners-css" alt="..." />
                                    </LazyLoad>
                                </div>
                                <div style={{marginTop: '20px'}}>
                                    <div className="card-body">
                                    <h5 className="card-title" style={{fontSize: '21px'}}><b>Jia Chen Qu</b></h5>
                                    {/* <p className="card-text" style={{marginTop: '10px', fontSize: '17px'}}>won 6th Place.</p> */}
                                    </div>
                                    {/* <div style={{marginTop: '20px', fontSize: '17px'}}>
                                        <p>[Bio coming soon]</p>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default WinnersFive